import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';

// Import from 'utils'
import { auth } from '..//utils/firebase';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Reset email sent. Check your inbox.");
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className='section'>
      <div className='section-content'> 
        <h2>Reset Password</h2>
        <form onSubmit={handleReset}>
          <input
            type="email"
            placeholder="Enter your email"
            onChange={e => setEmail(e.target.value)}
            required
          />
          <button type="submit">Send Reset Email</button>
        </form>
        <p>{message}</p>
      </div>
    </div>
  );
}
